// extracted by mini-css-extract-plugin
export default {"score":"score_score__h7-bK"};